module.exports = __webpack_public_path__ + "img/add.8539921c.png";